import React, {useEffect, useState} from 'react';
import {handleEnterClick} from "../../helpers/functions";

const Quantity = (props) => {
    const { onChange, max, min, initSelection } = props;
    const [counter, setCounter] = useState(initSelection ?? 1);

    useEffect(() => {
        onChange(counter)
    }, [counter]);

    return (
        <div className={'quantity-wrapper'}>
            <div className={'sign'}
                 onClick={() => setCounter(prev => prev === (min ?? 1) ? prev : prev - 1)}
                 onKeyDown={(e) => handleEnterClick(e, () => setCounter(prev => prev === (min ?? 1) ? prev : prev - 1))}
                 role="button"
                 tabIndex={0}
            >-</div>
            <div>{counter}</div>
            <div className={'sign'}
                 onClick={() => setCounter(prev => (max && prev === max) ? prev : prev + 1)}
                 onKeyDown={(e) => handleEnterClick(e, () => setCounter(prev => (max && prev === max) ? prev : prev + 1))}
                 role="button"
                 tabIndex={0}
            >+</div>
        </div>
    );
};

export default Quantity;